import { SetTrayResponse } from 'api/Responses/SetResponses';
import produce from 'immer';
import { TrayAction } from './trayActions';

export const initialTray: SetTrayResponse = {
  reference: '',
  name: '',
  non_standard: false,
  general_test: false,
  parts: {},
  language_metadata: {},
};

const trayReducer = produce((tray: SetTrayResponse, action: TrayAction) => {
  switch (action.type) {
    case 'REF':
      tray.reference = action.payload;
      break;
    case 'IMAGE':
      tray.image_file = action.payload.image;
      tray.original_image_file = action.payload.originalImage;
      tray.reference_tags_metadata = action.payload.referenceTags;
      break;
    case 'NAME':
      tray.name = action.payload;
      break;
    case 'NON_STANDARD':
      tray.non_standard = action.payload;
      break;
    case 'GENERAL_TEST':
      tray.general_test = action.payload;
      break;
  }
}, initialTray);

export default trayReducer;
